import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import {
  StSiteMasterSection,
  StSiteMasterSectionTitle,
  StSiteMasterStat,
  StSiteMasterStatGrid,
  StSiteMasterStatLabel,
  StSiteMasterStatValue,
} from 'components/SiteMaster/SiteMaster.styles';
import {
  getFieldValue,
  getMultilistDisplayNames,
  useSiteMasterRouteFields,
} from 'components/SiteMaster/utils';

type SiteInfoProps = ComponentProps & {
  fields: {
    sectionTitle?: Field<string>;
    activeStudiesText?: Field<string>;
    enrollingNowText?: Field<string>;
    yearsActiveText?: Field<string>;
    yearsActiveNumber?: Field<number>;
    languagesSpokenText?: Field<string>;
    languagesSpokenNumber?: Field<number>;
  };
};

const SiteInfo = (props: SiteInfoProps): JSX.Element => {
  const routeFields = useSiteMasterRouteFields();
  const { fields } = props;

  const activeStudies = getFieldValue(routeFields.activeStudiesCount) || '0';
  const enrollingNow = getFieldValue(routeFields.recruitingNowCount) || '0';
  const yearsActive =
    getFieldValue(routeFields.siteEstablishmentYearText) ||
    getFieldValue(fields.yearsActiveNumber) ||
    '-';
  const languages =
    String(getMultilistDisplayNames(routeFields.siteSupportedLanguages).length || '') ||
    getFieldValue(fields.languagesSpokenNumber) ||
    '-';

  return (
    <StSiteMasterSection>
      <StSiteMasterSectionTitle>
        <Text field={fields.sectionTitle} />
      </StSiteMasterSectionTitle>
      <StSiteMasterStatGrid>
        <StSiteMasterStat>
          <StSiteMasterStatValue>{activeStudies}</StSiteMasterStatValue>
          <StSiteMasterStatLabel>
            <Text field={fields.activeStudiesText} />
          </StSiteMasterStatLabel>
        </StSiteMasterStat>
        <StSiteMasterStat>
          <StSiteMasterStatValue>{enrollingNow}</StSiteMasterStatValue>
          <StSiteMasterStatLabel>
            <Text field={fields.enrollingNowText} />
          </StSiteMasterStatLabel>
        </StSiteMasterStat>
        <StSiteMasterStat>
          <StSiteMasterStatValue>{yearsActive}</StSiteMasterStatValue>
          <StSiteMasterStatLabel>
            <Text field={fields.yearsActiveText} />
          </StSiteMasterStatLabel>
        </StSiteMasterStat>
        <StSiteMasterStat>
          <StSiteMasterStatValue>{languages}</StSiteMasterStatValue>
          <StSiteMasterStatLabel>
            <Text field={fields.languagesSpokenText} />
          </StSiteMasterStatLabel>
        </StSiteMasterStat>
      </StSiteMasterStatGrid>
    </StSiteMasterSection>
  );
};

export default SiteInfo;
